import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import axiosInstance from '../axiosInterceptor'
import { toast } from 'react-toastify'
import CommonEditor from './CommonEditor'
import { ImageLink } from '../constants'

const AddMileStone = () => {
    const navigator = useNavigate();
    const location = useLocation();
    const editData = location.state
    const [data, setData] = useState({
        position: editData?.position || '',
        title: editData?.title || '',
        description: editData?.description || '',
        logo: editData?.logo || '',
    });

    const [errors, setErrors] = useState({
        position: '',
        title: '',
        description: '',
        logo: '',
    });

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'logo') {
            setData({ ...data, [name]: files.length > 0 ? files[0] : null });
        } else {
            setData({ ...data, [name]: value });
        }
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let hasErrors = false;

        if (!data.position.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                position: 'Position is required'
            }));
            hasErrors = true;
        }
        if (!data.title) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                title: 'Title is required'
            }));
            hasErrors = true;
        }
        if (!data.logo) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                logo: 'Logo is required'
            }));
            hasErrors = true;
        }

        if (hasErrors) {
            return;
        }

        try {
            const formData = new FormData();
            formData.append("position", data.position);
            formData.append("title", data.title);
            formData.append("description", data.description);

            if (data.logo instanceof File) {
                formData.append("logo", data.logo);
            }

            const response = await axiosInstance.post(`milestone/createMilestone`, formData);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/milestone");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };
    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append("position", data.position);
            formData.append("title", data.title);
            formData.append("description", data.description);

            if (data.logo instanceof File) {
                formData.append("logo", data.logo);
            }
            const response = await axiosInstance.put(`milestone/updateMilestone/${editData?._id}`, formData);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/milestone");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mt-5 mx-4">
                    <h3 className="page-title">Add Milestone </h3>
                </div>
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="col-md-8  ">
                        <div className="card">
                            <div className="card-body">
                                <form className="pt-3" onSubmit={editData?._id ? handleUpdate : handleSubmit}>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Position
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                id="position"
                                                name="position"
                                                placeholder="Enter position"
                                                value={data.position}
                                                onChange={handleChange}
                                            />
                                            {errors.position && <p className="text-danger">{errors.position}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Title
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="title"
                                                name="title"
                                                placeholder="Enter title"
                                                value={data.title}
                                                onChange={handleChange}
                                            />
                                            {errors.title && <p className="text-danger">{errors.title}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Description
                                        </label>
                                        <div className="col-sm-9">
                                            {/* <textarea
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="description"
                                                name="description"
                                                placeholder="Enter description"
                                                value={data.description}
                                                onChange={handleChange}
                                                style={{ height: '150px' }}
                                            />
                                            {errors.description && <p className="text-danger">{errors.description}</p>} */}
                                            <CommonEditor
                                                value={data.description}
                                                placeholder='Enter content ...'
                                                onChange={(value) => handleChange({ target: { name: 'description', value } })}
                                            />
                                            {errors.description && !data?.description?.trim() && (
                                                <div className="text-danger">Description is required</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Logo Img
                                        </label>

                                        <div className="col-sm-9">
                                            <input
                                                type="file"
                                                className="form-control form-control-sm"
                                                id="logo"
                                                name="logo"
                                                placeholder="Enter logo img"
                                                // value={data.desktopImg}
                                                onChange={handleChange}
                                            />
                                            {errors.logo && <p className="text-danger">{errors.logo}</p>}
                                        </div>
                                    </div>

                                    <div className='text-center'>
                                        <Link to="/milestone"><button className="btn btn-secondary mr-2">
                                            Back </button></Link>
                                        <button type="submit" className="btn btn-success">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    {data.logo && <div className="col-md-4 stretch-card">
                        <div className="card">
                            <div className="w-100 h-80 text-center mb-4">
                                <p className="mt-3">Logo Image Preview</p>
                                <br />
                                {data.logo instanceof File ? (
                                    <img src={URL.createObjectURL(data.logo)} alt="Preview" className="w-50 preview-img" />
                                ) : (
                                    <img src={ImageLink(data.logo)} alt="Preview" className="w-50 preview-img" />
                                )}
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        </>
    )
}

export default AddMileStone;